/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = {
      title: 'Open Orders',
      url:'#open_orders',
      target:0,
      badge: null,
      icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)"></path></svg>',
      isShow: 1,
      loader:null,
      body_html: '<div class="flits_open_orders"></div>'
    }
     var obj2 = {
      title: 'Shipped Orders',
      url:'#shipped_orders',
      target:0,
      badge: null,
      icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)"></path></svg>',
      isShow: 1,
      loader:null,
      body_html: '<div class="flits_shipped_orders"></div>'
    }
    settings.navs.splice(4, 0, obj);
    settings.navs.splice(5, 0, obj2);
    
  });


  function flitsCustomIntregation(){
    var flits_integrated_page = Flits(".flits-custom-page_1").children();
    var flits_integrated_page_mobile = Flits(".flits-custom-page_1-mobile").children();
    Flits("#flits_tab_open_orders .flits_open_orders").append(flits_integrated_page);
    Flits("#flits_mobile_tab_open_orders .flits_open_orders").append(flits_integrated_page_mobile);

    var flits_integrated_page_2 = Flits(".flits-custom-page_2").children();
    var flits_integrated_page_2_mobile = Flits(".flits-custom-page_2-mobile").children();
    Flits("#flits_tab_shipped_orders .flits_shipped_orders").append(flits_integrated_page_2);
    Flits("#flits_mobile_tab_shipped_orders .flits_shipped_orders").append(flits_integrated_page_2_mobile);
    
    Flits(".flits-custom-page_1").remove();
    Flits(".flits-custom-page_1-mobile").remove();
    Flits(".flits-custom-page_2").remove();
    Flits(".flits-custom-page_2-mobile").remove();
  }

  Flits(document).on('Flits:AccountPage:Loaded', function(event){  
    setTimeout(function() {
      flitsCustomIntregation();
    },1500);    
  });

  
}(Flits));